import styled from '@emotion/styled';
import { mainColors } from 'src/assets/colors';
interface ButtonWrapperType {
    isDisabled: boolean;
}
export const ButtonWrapper = styled('div', { label: 'ButtonWrapper' })<ButtonWrapperType>`
    display: flex;
    ${({ isDisabled }): string => isDisabled === true ? `
    opacity: 0.5;
    ` : `
    `}
`;

interface ButtonTagType {
    isDeleteButton?: boolean;
}

export const ButtonTag = styled('button', { label: 'ButtonTag' })<ButtonTagType>`
    user-select: none;
    margin-top: 5px;
    width: 100%;

    ${({ isDeleteButton }): string => isDeleteButton === true ? `
        background: ${mainColors.grays.gray200};
    ` : ''}
`;
